(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wordpress/blockEditor"), require("@wordpress/components"), require("@wordpress/blocks"));
	else if(typeof define === 'function' && define.amd)
		define(["@wordpress/blockEditor", "@wordpress/components", "@wordpress/blocks"], factory);
	else if(typeof exports === 'object')
		exports["Drawflow"] = factory(require("@wordpress/blockEditor"), require("@wordpress/components"), require("@wordpress/blocks"));
	else
		root["Drawflow"] = factory(root["wp"]["blockEditor"], root["wp"]["components"], root["wp"]["blocks"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 